import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { Logger } from "@app/@core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { CardsService } from "@app/@shared/api/cards.service";
import { NotificationService } from "@app/@shared/services/notification.service";
import { Subscription } from "rxjs";
import _ from "lodash";
import { Card } from "@app/@shared/models/card";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";

@Component({
  selector: "app-card-details",
  templateUrl: "./card-details.component.html",
  styleUrls: ["./card-details.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CardDetailsComponent implements OnInit, OnDestroy {
  log = new Logger(CardDetailsComponent.name);

  isCardLoading: boolean;
  email: string;
  username: string;
  domain: string;
  safeSignature: SafeStyle;

  @Input() card: Card;

  subs: Subscription;
  form: FormGroup;
  isUpdating = false;
  userProfile: string;

  constructor(
    private route: ActivatedRoute,
    private cardsService: CardsService,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.subs = this.route.params.subscribe((params) => {
      this.email = params["email"];
      this.domain = this.email.split("@")[1];
      this.username = this.email.split("@")[0];
      this._loadData();
    });
  }

  ngOnDestroy(): void {
    this.subs?.unsubscribe();
  }

  private _loadData() {
    this.isCardLoading = true;

    this.cardsService
      .getCardByEmail(this.domain, this.username)
      .then(
        (result) => {
          this.card = result;
          this.safeSignature = this.sanitizer.bypassSecurityTrustHtml(
            this.card.signature
          );
        },
        (error) => {
          this.log.error("Error getCardByEmail: ", error);
          this.notificationService.open("Error getting the card.");
        }
      )
      .finally(() => (this.isCardLoading = false));
  }

}
